// Unpublished Work © 2020-2022 Deere & Company

import * as actions from '../../action-list';
import {ApplicationStatus} from '../../state/struct/customer-search/application-status';

const setPageStatus = (state, action) => ApplicationStatus.update(state, {
    pageStatus: {
        $set: action.pageStatus
    }
});

const setBreadcrumbTitle = (state, action) => ApplicationStatus.update(state, {
    breadcrumbTitle: {
        $set: action.breadcrumbTitle
    }
});

const updateCountryStateLoadingStatus = (state, action) => ApplicationStatus.update(state, {
    areStateFacetsLoaded: {
        $set: action.areStateFacetsLoaded
    }
});

const updateCitiesDropdownPageStatus = (state, action) => ApplicationStatus.update(state, {
    areCitiesLoaded: {
        $set: action.areCitiesLoaded
    }
});

const updateHasSearchStarted = (state, action) => {
    const update = {
        hasSearchStarted: {
            $set: action.hasSearchStarted
        }
    };

    return ApplicationStatus.update(state, update);
};

const enableCustomerSearchViewResults = (state, action) => {
    const update = {
        isViewResultShown: {
            $set: action.isViewResultVisible
        }
    };

    return ApplicationStatus.update(state, update);
};

const updateMergeCustomerStatus = (state, action) => {
    const update = {
        mergeCustomer: {
            $merge: action.mergeCustomer
        }
    };

    return ApplicationStatus.update(state, update);
};

const updateMergeCustomerModalStatus = (state, action) => {
    const update = {
        mergeCustomer: {
            $merge: {
                isModalShown: action.isModalShown
            }
        }
    };

    return ApplicationStatus.update(state, update);
};

const updateFullPageLoadingStatus = (state, action) => ApplicationStatus.update(state, {
    fullPageLoadingStatus: {
        $set: action.status
    }
});

const updateMergeRequestFullPageLoaderShown = (state, action) => {
    const update = {
        mergeCustomer: {
            $merge: {
                isMergeRequestFullPageLoaderShown: action.isLoadingShown
            }
        }
    };

    return ApplicationStatus.update(state, update);
};

const setCustomerSearchServiceError = (state, action) => {
    const update = {
        customerSearchError: {
            $merge: action.customerSearchError
        }
    };

    return ApplicationStatus.update(state, update);
};

const resetIsSaveAndRestoreDefaultFacetShown = (state) => ApplicationStatus.update(state, {
    isRestoreDefaultFacetShown: {
        $set: new ApplicationStatus({}).isRestoreDefaultFacetShown
    },
    isSaveDefaultFacetShown: {
        $set: new ApplicationStatus({}).isSaveDefaultFacetShown
    }
});

const enableIsSaveAndRestoreDefaultFacetShown = (state) => ApplicationStatus.update(state, {
    isRestoreDefaultFacetShown: {
        $set: true
    },
    isSaveDefaultFacetShown: {
        $set: true
    }
});

export const applicationStatus = (state = new ApplicationStatus({}), action = {}) => {
    const actionHandlers = {
        [actions.RESET_SAVE_DEFAULT_STATUS]: resetIsSaveAndRestoreDefaultFacetShown,
        [actions.SET_BREADCRUMB_TITLE]: setBreadcrumbTitle,
        [actions.SET_CUSTOMER_SEARCH_ERROR]: setCustomerSearchServiceError,
        [actions.SET_CUSTOMER_SEARCH_PAGE_STATUS]: setPageStatus,
        [actions.SET_SEARCH_STARTED]: updateHasSearchStarted,
        [actions.UPDATE_COUNTRY_STATE_LOADING_STATUS]: updateCountryStateLoadingStatus,
        [actions.UPDATE_CUSTOMER_TYPE_FACET]: enableIsSaveAndRestoreDefaultFacetShown,
        [actions.UPDATE_FULL_PAGE_LOADING_STATUS]: updateFullPageLoadingStatus,
        [actions.UPDATE_INPUT_TYPE_FACET]: enableIsSaveAndRestoreDefaultFacetShown,
        [actions.UPDATE_UNIQUE_INPUT_TYPE_FACET]: enableIsSaveAndRestoreDefaultFacetShown,
        [actions.UPDATE_MERGE_CUSTOMER_MODAL_STATUS]: updateMergeCustomerModalStatus,
        [actions.UPDATE_MERGE_CUSTOMER_STATUS]: updateMergeCustomerStatus,
        [actions.UPDATE_SEARCH_VIEW_RESULTS_BUTTON_VISIBILITY]: enableCustomerSearchViewResults,
        [actions.UPDATE_STATES_FACET]: enableIsSaveAndRestoreDefaultFacetShown,
        [actions.SET_CITIES_PAGE_STATUS]: updateCitiesDropdownPageStatus,
        [actions.UPDATE_MULTIPLE_INPUT_TYPE_FACETS]: enableIsSaveAndRestoreDefaultFacetShown,
        [actions.UPDATE_MERGE_REQUEST_FULL_PAGE_LOADER_SHOWN]: updateMergeRequestFullPageLoaderShown
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
